import React, { createContext, use, ReactNode, useMemo } from "react";
import { useFileExplorer } from "./useFileExplorer";
import { FileManagerFile } from "./types";
import { UploadedFileType } from "./upload/uploadedFileType";

interface FileExplorerContextType {
  files: FileManagerFile[];
  isLoading: boolean;
  isRefreshing: boolean;
  uploadLoading: boolean;
  selectedFileType: UploadedFileType;
  setSelectedFileType: (fileType: UploadedFileType) => void;
  fileTypeOptions: UploadedFileType[];
  onFileUpload: (files: FileList) => Promise<void>;
  onFileDownload: (files: FileManagerFile[]) => void;
  onRefresh: () => Promise<void>;
}

const FileExplorerContext = createContext<FileExplorerContextType | undefined>(
  undefined
);

interface FileExplorerProviderProps {
  children: ReactNode;
}

export const FileExplorerProvider: React.FC<FileExplorerProviderProps> = ({
  children,
}) => {
  const fileExplorerData = useFileExplorer();

  const contextValue: FileExplorerContextType = useMemo(
    () => fileExplorerData,
    [fileExplorerData]
  );

  return (
    <FileExplorerContext value={contextValue}>{children}</FileExplorerContext>
  );
};

export const useFileExplorerContext = (): FileExplorerContextType => {
  const context = use(FileExplorerContext);
  if (context === undefined) {
    throw new Error(
      "useFileExplorerContext must be used within a FileExplorerProvider"
    );
  }
  return context;
};
